import { NgModule, APP_INITIALIZER } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { CoreRoutingModule } from './core-routing.module';
import { ErrorComponent } from './components/error/error.component';
import { SessionTimeoutDialogComponent } from './components/session-timeout-dialog/session-timeout-dialog.component';
import { ConfigurationService } from './services/configuration.service';
import { MatDialogModule, MatButtonModule, MatIconModule, MatToolbarModule } from '@angular/material';

/**
 * A Core Module contains code that will be used to instantiate
 * your app and load some core functionality. In the Core Module,
 * we commonly place our singleton services and modules that will
 * be used across the app but only need to be imported once.
 * Examples are Authentication Service or LocalStorage Service,
 * but also modules like HttpClientModule, <FeatureModule>.forRoot(…),
 * The CoreModule is then imported into the AppModule.
 */

@NgModule({
  declarations: [
    ErrorComponent,
    SessionTimeoutDialogComponent
  ],
  imports: [
    HttpClientModule,
    MatButtonModule,
    MatDialogModule,
    MatIconModule,
    MatToolbarModule,
    CoreRoutingModule
  ],
  exports: [
    HttpClientModule
    // Feature Module 1,
    // Feature Module 2,
  ],
  entryComponents: [
    SessionTimeoutDialogComponent,
  ],
  providers: [
    {
      provide : APP_INITIALIZER,
      multi : true,
      deps : [ConfigurationService], useFactory : (configurationService: ConfigurationService) => configurationService.intialize()
    }
  ]
})
export class CoreModule {
}
